import icCloseSquare from "assets/images/ic-close-square.svg";
import Button from "components/commons/button";
import { Import } from "components/commons/import/Import";
import Modal from "components/commons/modal";
import { TABLE_HAPPINESS_INDEX_IMPORT } from "configs/hr-metrics/configTableHappinessIndexList";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { API_HAPPINESS_INDEX } from "services/apiHappinessIndex";

export const ImportHappinessIndexContainer = ({show, onHide}) => {
    const [searchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [isComplete, setIsComplete] = useState(false)

    useEffect(() => {
        if (show) setIsComplete(false)
    }, [show])

    const api = {
        fetchTemplate: API_HAPPINESS_INDEX.DOWNLOAD_TEMPLATE,
        fetchValidate:{...API_HAPPINESS_INDEX.FILE_VALIDATION, api: API_HAPPINESS_INDEX.FILE_VALIDATION.api + `/${periodId}`},
        fetchImport:{...API_HAPPINESS_INDEX.IMPORT, api: API_HAPPINESS_INDEX.IMPORT.api + `/${periodId}`},
    }

    const props = {
        title: 'Happiness Index',
        columnTableView: TABLE_HAPPINESS_INDEX_IMPORT,
        api: api,
        returnTitle: 'View Happiness Index',
        onHide: onHide,
        setCompleteImport: (value) => setIsComplete(value)
    }

    return (
        <Modal
            dialogClassName="w-[70%]"
            contentClassName="rounded-xl"
            show={show}
        >
            <div className={"px-6 py-3 flex flex-row items-center justify-between border-b"}>
                <p className={"font-semibold text-md"}>Import Data</p>
                <Button type="outline" shape="circle" size="small" icon={icCloseSquare} onClick={() => onHide(isComplete)}/>
            </div>
            <div className="overflow-auto">
                <Import {...props}/>
            </div>
        </Modal>
    )
}
